import React, {FC} from "react";
import {Text} from "@constructor/components";
import {useMarketItemContext} from "./context";

const MarketItemPrice: FC = (props) => {
    const item = useMarketItemContext();
    if (!item) {
        return null;
    }

    const replaces = {
        price: item.price
    }
    return (
        <Text text={item.price} {...props} replaces={replaces} />
    )
}

export default MarketItemPrice;